import { useEffect, useState } from 'react';
// Detects a new website release (every deploy changes /api/health "release") and remembers an active call
// across reloads so MALVO can rejoin it afterwards, like Discord does after an update.
declare const __MALVO_RELEASE__: string;
let boot = typeof __MALVO_RELEASE__ === 'string' ? __MALVO_RELEASE__ : '';
let available = false;
const listeners = new Set<(v: boolean) => void>();
let last = 0;
// A click only hides this notice until the actual reload, never future releases.
let hidden = false;
let checking: Promise<boolean> | null = null;
export const updateButtonVisible = (ready: boolean) => ready && !hidden;
export async function checkForUpdate(force = false) {
  if (checking) return checking;
  if (available || (!force && Date.now() - last < 30000)) return available;
  last = Date.now();
  checking = (async () => {
  const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 8000);
  try {
    const r = await fetch('/api/health', { cache: 'no-store', signal: controller.signal });
    if (!r.ok) return available;
    const data = await r.json(), release = data.release;
    if (!data.ok || typeof release !== 'string' || !release || release === 'unknown' || release.length > 180) return available;
    if (!boot) boot = release;
    else if (release !== boot) { available = true; listeners.forEach(f => f(true)); }
  } catch { /* Offline checks do not invent an available update. */ }
  finally { clearTimeout(timeout); }
  return available;
  })().finally(() => { checking = null; });
  return checking;
}
export function useWebUpdate() {
  const [v, set] = useState(available);
  useEffect(() => {
    listeners.add(set); void checkForUpdate(true);
    const t = window.setInterval(() => { if (!document.hidden) void checkForUpdate(); }, 30000);
    const vis = () => { if (!document.hidden) void checkForUpdate(); };
    document.addEventListener('visibilitychange', vis); window.addEventListener('focus', vis);
    return () => { listeners.delete(set); clearInterval(t); document.removeEventListener('visibilitychange', vis); window.removeEventListener('focus', vis); };
  }, []);
  return v;
}

const KEY = 'malvo-call-resume';
let updating = false;
export type Resume = { id: string; name: string; at: number; auto?: boolean };
export function rememberCall(call: { id: string; name: string } | null, auto = false) {
  try { if (call) sessionStorage.setItem(KEY, JSON.stringify({ id: call.id, name: call.name, at: Date.now(), auto: auto || updating })); else sessionStorage.removeItem(KEY); } catch {}
}
export function takeResume(): Resume | null {
  try { const r = JSON.parse(sessionStorage.getItem(KEY) || 'null') as Resume | null; sessionStorage.removeItem(KEY); return r && r.id && Date.now() - r.at < 15 * 60000 ? r : null; } catch { return null; }
}
export function installUpdate(call: { id: string; name: string } | null, clicked = false) {
  if (updating) return;
  if (clicked) { hidden = true; listeners.forEach(f => f(false)); }
  updating = true; rememberCall(call, true);
  if(clicked){window.dispatchEvent(new Event('malvo-updating'));setTimeout(()=>location.reload(),matchMedia('(prefers-reduced-motion: reduce)').matches?80:700)}else location.reload();
}
